import { render, staticRenderFns } from "./PotentialRevenue.vue?vue&type=template&id=b8fc4b22&scoped=true&"
import script from "./PotentialRevenue.vue?vue&type=script&lang=js&"
export * from "./PotentialRevenue.vue?vue&type=script&lang=js&"
import style0 from "./PotentialRevenue.vue?vue&type=style&index=0&id=b8fc4b22&prod&scoped=true&lang=css&"
import style1 from "./PotentialRevenue.vue?vue&type=style&index=1&id=b8fc4b22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fc4b22",
  null
  
)

export default component.exports